











































import Vue from 'vue'
import * as easing from '@hscmap/easing'

export default Vue.extend({
  props: {
    module: { required: true },
  },
  computed: {
    easings() {
      return Object.keys(easing)
    },
  },
})
